module.exports = __webpack_public_path__ + "static/img/checkbox-circle-fill.30711f3c.svg";